import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'

export const KeyChart: React.FunctionComponent = (props) => {
    return (
        <BPMChart {...props} title='Keys' subTitle='By Downloads' type='tree'
            onRequestLoad={(options, signal) => {
                return (BPMAnalyticsAPI.get<any>('downloads/key', options, signal))
            }} allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{ name: 'Downloads', valueField: 'count', argumentField: 'key' }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Downloads/charts/KeyChart.tsx